// import components
import { styled, Box, Link, Button, Typography, Divider } from '@mui/material';

// import constants
import { rgbaPrimary, rgbaWhite } from 'constants/colors';

export const StyledSettingByTypeBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4)
}));

export const StyledRoundsBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center'
}));

export const StyledDisabledOverlayBox = styled(Box)(() => ({
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: rgbaWhite(0.5),
  zIndex: 10,
  cursor: 'not-allowed'
}));

export const StyledAiBasicIntroBox = styled(Box)(({ theme }) => ({
  backgroundColor: rgbaPrimary(0.05),
  border: `1px solid ${rgbaPrimary(0.4)}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(4),
  textWrap: 'balance',
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  alignItems: 'center'
}));

export const StyledLeftContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
  alignItems: 'center',
  color: theme.palette.primary.main
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
  gap: theme.spacing(3),
  alignItems: 'center',
  lineHeight: 'normal',
  textDecoration: 'none',
  cursor: 'pointer'
}));

export const StyledRoundsButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1, 3)
}));

export const StyledDeleteRoundsButton = styled(Button)(({ theme }) => ({
  border: 0,
  width: theme.spacing(4),
  height: theme.spacing(4),
  padding: theme.spacing(3.5),
  color: theme.palette.error.main,
  backgroundColor: theme.vars.palette.Alert.errorStandardBg,
  borderRadius: '50%',
  minWidth: 'auto',

  '&:hover': {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.background.paper
  }
}));

export const StyledAddRoundButton = styled(Button)(() => ({
  alignSelf: 'flex-end'
}));

export const StyledRoundsLeftBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  flexWrap: 'wrap'
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  color: rgbaPrimary(0.9)
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(2, 0)
}));

export const StyledAiMatchFooterBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: theme.spacing(2)
}));

export const StyledHeaderTypography = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1.5)
}));
